import { REDACTED_CONTACT_KEYS_MAP } from "../data/contacts/constants";

export const steps = [
  {
    title: 'Select Contacts',
    description: 'Select all contacts that you wish to append contact information to. Any duplicate contacts you select, or any contacts that have already been appended to, will not be processed.',
  },
  {
    title: 'Payment',
    description: 'Please review your order. You will be charged $rate cents per successfully appended record. If a record comes back with multiple telephone numbers and emails addresses, you still only pay $rate cents one time.\n\nYour card will be authorized for the total number of records selected. Once the process is complete, you will be refunded for any contacts we were not able to find contact information for.',
    next: 'Place Order',
  },
  {
    title: 'Confirmation',
    description: 'Your order is complete. The process can take several minutes or more depending on the number of contacts selected. Please check back to the Contacts screen periodically to see the status of your order. If you would like to enter a custom name for this order, please enter it below and click "Done".',
    next: 'Done',
  },
];

export const brand = {
  REI: 'rei',
  GEN: 'gen'
};

export const buttonText = {
  SAVE: 'Save',
  SAVED: 'Saved'
}

export const phoneTypes = [
  { label: 'Mobile', value: 'MOBILE' },
  { label: 'Landline', value: 'LANDLINE' },
  { label: 'Other', value: 'OTHER' },
];

export const emailTypes = [
  { label: 'Home', value: 'HOME' },
  { label: 'Work', value: 'WORK' },
  { label: 'Other', value: 'OTHER' },
];

export const validation = {
  NameRequired: 'First Name, Last Name, or Company Name is required.',
  ContactTypeRequired: 'Please select a contact type.',
  ContactStatusRequired: 'Please select a contact status.'
}

export const DncOptions = [
  { label: '', value: null },
  { label: 'DNC', value: 'D' },
  { label: 'PAB', value: 'A' },
  { label: 'DNC / PAB', value: 'DA' },
];

export const statusText = {
  Complete: 'Complete',
  Processing: 'Processing'
}

export const promptText = {
  NewGroupName: 'Please enter a new name for this group.',

}
export const promptTitle = {
  RenameGroup: 'Rename Group',
  CreateGroup: 'Create Group'
}

// A number is considered redacted if it is present in to the REDACTED_CONTACT_KEYS_MAP
export const isRedactedNumber = (number) => {
  return REDACTED_CONTACT_KEYS_MAP[number];
}

// A contact is considered redacted if both the first name and last name is present in REDACTED_CONTACT_KEYS_MAP
export const isRedactedContact = (contact) => {
  return REDACTED_CONTACT_KEYS_MAP[contact?.firstName] && REDACTED_CONTACT_KEYS_MAP[contact?.lastName];
}

// A property's owner is redacted if either owner's full name is a redacted key. The property details
// page and the property AI chat both use this to hide the owner's contact info.
export const isRedactedOwner = (owner1FullName, owner2FullName) => Boolean(
  isRedactedContact({ firstName: owner1FullName, lastName: owner1FullName }) ||
  isRedactedContact({ firstName: owner2FullName, lastName: owner2FullName })
);